/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable radix */
// Questionnaire.js
import React, { useState, useEffect, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { API } from "../../apis/api";
import Header from "../../components/Questionnaire/Header";
import FormTabs from "../../components/Questionnaire/FormTabs";
import FormContent from "../../components/Questionnaire/FormContent";
import Footer from "../../components/Questionnaire/Footer";
import CategorySelectionModal from "../../components/CategorySelectionModal/CategorySelectionModal";
import DraftPromptDialog from "../../components/DraftPromptDialog/DraftPromptDialog";
import { ROUTES, USER_TYPE } from "../../constants";
import ConfirmDelete from "../../components/Questionnaire/ConfirmDelete";
import { errorSnackbar } from "../../redux/features/customSnackbar/action";
import {
  fetchTicketById,
  prepareDividendEntriesFromTicket,
} from "../IEPFReport/ticketService";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
}));

// Helper to merge form structure with answers for rendering
const mergeDataForRender = (formData, responses) => {
  if (!formData) return null;
  return {
    ...formData,
    sections: formData.sections.map((section) => ({
      ...section,
      questions: section.questions.map((question) => {
        const answer = responses[question.id];
        const hasAnswer = answer !== undefined && answer !== null;

        // Default radio/toggle to false if no answer exists
        if (
          question.control_type === "radio" ||
          question.control_type === "toggle"
        ) {
          const value = hasAnswer ? !!answer : false;
          return {
            ...question,
            answer: value,
            value,
            checked: value,
            displayValue: value ? "Yes" : "No",
          };
        }

        return {
          ...question,
          answer: hasAnswer ? answer : question.answer, // Fallback to original answer
          value: hasAnswer ? answer : question.value,
        };
      }),
    })),
  };
};

function Questionnaire() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const ticketId = queryParams.get("ticketId");
  const ticketCode = queryParams.get("ticketCode");
  const mode = queryParams.get("mode") || "edit";

  // --- Simplified State ---
  const [allCategories, setAllCategories] = useState([]);
  const [visibleCategories, setVisibleCategories] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  // The immutable structure of all forms
  const [allFormsData, setAllFormsData] = useState({});
  // The state of user's answers for all forms
  const [allFormResponses, setAllFormResponses] = useState({});

  const [loading, setLoading] = useState(true);
  const [isDeleteModalLoading,setIsDeleteModalLoading]=useState(false)
  const [error, setError] = useState(null);
  const [lastSaved, setLastSaved] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [reasonForReject, setReasonForReject] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [formRemarks, setFormRemarks] = useState("");
  const [formDividendEntries, setFormDividendEntries] = useState([]);
  const [ticketStatus, setTicketStatus] = useState("");

  const userId = useSelector((state)=>state.auth.user.userId)

  // --- Derived State (Computed on each render) ---
  const currentFormName = visibleCategories[activeTabIndex];
  const currentBaseFormData = allFormsData[currentFormName];
  const currentFormResponses = useMemo(
    () => allFormResponses[currentFormName] || {},
    [currentFormName, allFormResponses]
  );
  // The data passed to the form for rendering is a merge of the base structure and current responses.
  const currentFormDataForRender = useMemo(
    () => mergeDataForRender(currentBaseFormData, currentFormResponses),
    [currentBaseFormData, currentFormResponses]
  );

  // Add this helper function inside the Questionnaire component
  const validateForms = (visibleCategories, allFormsData, allFormResponses) => {
    const errorMessages = [];
    const invalidFields = {}; // Use an object for quick lookups

    for (const formName of visibleCategories) {
      const formData = allFormsData[formName];
      const formResponses = allFormResponses[formName] || {};
      let formHasError = false;

      if (!formData || !formData.sections) continue;

      for (const section of formData.sections) {
        for (const question of section.questions) {
          if (question.is_required) {
            const answer = formResponses[question.id];
            let isAnswered = false;

            if (answer !== null && answer !== undefined) {
              if (Array.isArray(answer)) {
                isAnswered = answer.length > 0;
              } else if (typeof answer === "string") {
                isAnswered = answer.trim() !== "";
              } else {
                isAnswered = true; // Covers booleans and numbers
              }
            }

            if (!isAnswered) {
              formHasError = true;
              invalidFields[question.id] = true; // Add the question ID to our map
            }
          }
        }
      }

      if (formHasError) {
        errorMessages.push(
          `Please fill in all required fields in the "${formName}" form.`
        );
      }
    }

    return {
      isValid: errorMessages.length === 0,
      errors: errorMessages,
      invalidFields, // Return the map of invalid fields
    };
  };

  // --- Data Fetching and Processing ---

  // Helper function to process fetched data and set initial state
  const processFetchedData = (formData, answersData) => {
    const answersMap = {};
    if (answersData?.sections) {
      answersData.sections.forEach((section) => {
        section.questions?.forEach((q) => {
          answersMap[q.question_master_id] = {
            value: q.values,
            remark: q.remark,
            confidence: q.confidence,
            ai_answer_reason: q.ai_answer_reason || "",
          };
        });
      });
    }
    if (answersData?.ticket_remarks?.[0]?.remark) {
      setFormRemarks(answersData?.ticket_remarks?.[0]?.remark);
    }

    if (answersData?.dividend_info?.entries) {
      const data = prepareDividendEntriesFromTicket(
        answersData?.dividend_info?.entries
      );

      setFormDividendEntries(data);
    }

    const responses = {};
    const processedSections = formData.sections.map((section) => ({
      ...section,
      questions: section.questions.map((question) => {
        const answer = answersMap[question.id];
        let processedQuestion = { ...question };
        let finalAnswer = null;

        if (
          question.control_type === "radio" ||
          question.control_type === "toggle"
        ) {
          let value = false;
          if (answer) {
            const answerValue = String(answer.value).toLowerCase();
            value = answerValue === "yes" || answerValue === "true";
          }
          finalAnswer = value;
          processedQuestion = {
            ...processedQuestion,
            answer: value,
            value,
            checked: value,
            displayValue: value ? "Yes" : "No",
          };
        } else if (answer) {
          finalAnswer = answer.value;
          // Add other type processing if needed (e.g., date, multi-select)
          processedQuestion = {
            ...processedQuestion,
            answer: answer.value,
            value: answer.value,
            ...answer,
          };
        }

        // Initialize responses with a value
        responses[question.id] = finalAnswer;

        return processedQuestion;
      }),
    }));

    return {
      processedFormData: { ...formData, sections: processedSections },
      initialResponses: responses,
    };
  };
  const handleFormRemarkChange = useCallback((remark) => {
    setFormRemarks(remark);
  }, []);

  const fetchAllFormsData = useCallback(
    async (formNames) => {
      setLoading(true);
      setError(null);
      try {
        const formPromises = formNames.map(async (formName) => {
          try {
            const formDetailPromise = API.post("/ticket/form-detail/", {
              form_name: formName,
              sub:userId,
            });
            const formAnswersPromise = API.post(
              "/ticket/get-ticket-questions-details/",
              { ticket_code: ticketCode, form_name: formName,sub:userId, }
            ).catch((err) => {
              if (err.response?.status === 404 || err.response?.status === 400)
                return null; // No answers yet, not an error
              throw err;
            });

            const [formResponse, answersResponse] = await Promise.all([
              formDetailPromise,
              formAnswersPromise,
            ]);

            const { processedFormData, initialResponses } = processFetchedData(
              formResponse.data,
              answersResponse?.data,
              formName
            );

            return { formName, processedFormData, initialResponses };
          } catch (err) {
            console.error(`Error fetching data for form "${formName}":`, err);
            return null; // Return null for failed forms
          }
        });

        const results = (await Promise.all(formPromises)).filter(Boolean);

        const newAllFormsData = {};
        const newAllFormResponses = {};
        results.forEach((result) => {
          newAllFormsData[result.formName] = result.processedFormData;
          newAllFormResponses[result.formName] = result.initialResponses;
        });

        setAllFormsData(newAllFormsData);
        setAllFormResponses(newAllFormResponses);
      } catch (err) {
        console.error("Error fetching all forms data:", err);
        setError(`Failed to load forms data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    },
    [ticketCode]
  );

  useEffect(() => {
    const fetchFormNames = async () => {
      try {
        const response = await API.post("/ticket/get-ticket-form-names/", {
          ticket_code: ticketCode,
          sub:userId,
        });
        if (response.data?.data) {
          const formNames = response.data.data.map((form) => form.meta_value);
          setAllCategories(formNames);
          setVisibleCategories(formNames);
          if (formNames.length > 0) {
            await fetchAllFormsData(formNames);
          } else {
            setLoading(false);
          }
        } else {
          throw new Error("Invalid response format for form names");
        }
      } catch (err) {
        console.error("Error fetching form names:", err);
        setError(`Failed to load form categories: ${err.message}`);
        setLoading(false);
      }
    };
    fetchFormNames();
  }, [ticketCode, fetchAllFormsData]);

  useEffect(() => {
    if (ticketCode) {
      const fetchStatus = async () => {
        try {
          const { status: TicketStatus } = await fetchTicketById(ticketCode,userId);
          setTicketStatus(TicketStatus);
        } catch (error) {
          console.error("Error fetching ticket status:", error);
        }
      };
      fetchStatus();
    }
  }, [ticketCode]);

  // --- Event Handlers ---

  const handleTabChange = useCallback((event, newValue) => {
    setActiveTabIndex(newValue);
  }, []);

  const handleControlChange = useCallback(
    (questionId, value) => {
      // Clear the validation error for this field as the user is editing it
      if (validationErrors[questionId]) {
        setValidationErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[questionId];
          return newErrors;
        });
      }

      const question = currentBaseFormData?.sections
        .flatMap((s) => s.questions)
        .find((q) => q.id === questionId);

      if (!question) return;

      const storeValue =
        question.control_type === "radio" || question.control_type === "toggle"
          ? !!value
          : value;

      setAllFormResponses((prev) => ({
        ...prev,
        [currentFormName]: {
          ...prev[currentFormName],
          [questionId]: storeValue,
        },
      }));
    },
    [currentFormName, currentBaseFormData, validationErrors] // Add validationErrors to dependency array
  );

  const handleMultiControlChange = useCallback(
    (questionId, detailId, isChecked) => {
      // Clear the validation error for this field as the user is editing it
      if (validationErrors[questionId]) {
        setValidationErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[questionId];
          return newErrors;
        });
      }
      // ... rest of the function is the same
      setAllFormResponses((prev) => {
        const currentSelections = prev[currentFormName]?.[questionId] || [];
        const newSelections = isChecked
          ? [...currentSelections, detailId]
          : currentSelections.filter((id) => id !== detailId);

        return {
          ...prev,
          [currentFormName]: {
            ...prev[currentFormName],
            [questionId]: newSelections,
          },
        };
      });
    },
    [currentFormName, validationErrors]
  );

  const prepareSubmitPayload = (actionType) => {
    const questions = [];
    Object.entries(allFormResponses).forEach(([formName, responses]) => {
      const formData = allFormsData[formName];
      if (!formData) return;

      formData.sections.forEach((section) => {
        section.questions.forEach((question) => {
          const value = responses[question.id];
          const shouldInclude =
            value !== null && value !== undefined && value !== "";

          if (shouldInclude) {
            let processedValue;

            if (typeof value === "boolean") {
              processedValue = value ? "YES" : "NO";
            } else if (Array.isArray(value)) {
              // Convert array to comma-separated string
              processedValue = value.join(",");
            } else {
              // Convert to string and apply formatting if it's a date
              let strVal = String(value);

              // Format date: convert "YYYY-MM-DD" to "DD/MM/YYYY"
              if (question.control_type === "date") {
                const isoMatch = /^\d{4}-\d{2}-\d{2}$/.test(strVal);
                if (isoMatch) {
                  const [year, month, day] = strVal.split("-");
                  strVal = `${day}/${month}/${year}`;
                }
              }

              processedValue = strVal;
            }

            if (processedValue) {
              questions.push({
                question_header_master: section.header_id || section.id,
                question_master: question.id,
                values: processedValue,
              });
            }
          }
        });
      });
    });

    return {
      ticket_code: ticketCode,
      action_type: actionType,
      ticket_remarks: formRemarks,
      questions,
      sub:userId,
    };
  };

  const handleSubmit = async () => {
    setValidationErrors({});

    const validationResult = validateForms(
      visibleCategories,
      allFormsData,
      allFormResponses
    );

    if (!validationResult.isValid) {
      setValidationErrors(validationResult.invalidFields); // Set the state with invalid field IDs
      dispatch(
        errorSnackbar({
          title: "Fill All Fields",
          subtitle: "",
          duration: 6000,
        })
      );
      return; // Stop the submission
    }

    try {
      const payload = prepareSubmitPayload("PERFORMER_APPROVED");
      await API.post("/ticket/create-ticket-questions-details/", payload);
      history.goBack();
    } catch (err) {
      // console.error("Error submitting forms:", err);
      // setError(`Failed to submit forms: ${err.message}`);
      if (err.response && err.response.status === 400) {
        dispatch(
          errorSnackbar({
            title: "Failed to submit the forms",
            subtitle: `${err.message}`,
            duration: 5000,
          })
        );
      } else {
        console.error("Error submitting forms", err.message);
      }
    }
  };
  const handleSaveAsDraft = useCallback(async () => {
    try {
      const payload = prepareSubmitPayload("DRAFT");
      console.log("Saving draft data:", payload);
      await API.post("/ticket/create-ticket-questions-details/", payload);
      setLastSaved(new Date().toISOString());
    } catch (err) {
      console.error("Error saving draft:", err);
      setError(`Failed to save draft: ${err.message}`);
    }
  }, [allFormResponses, allFormsData, ticketCode, formRemarks]);

  const handleBack = () => history.goBack();
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleCategoriesChange = (newCategories) => {
    if (newCategories.length === 0) return;
    setVisibleCategories(newCategories);
    if (!newCategories.includes(currentFormName)) {
      setActiveTabIndex(0);
    }
  };

  const handleReset = () => {
    setValidationErrors({});
    if (allCategories.length > 0) {
      fetchAllFormsData(allCategories);
    }
  };

  const handleApproveOrReject = async (action) => {
    setIsDeleteModalLoading(true)
    try {
      const payload = {
        ticket_code: ticketCode,
        reject_reason: reasonForReject,
        sub:userId,
        ticket_status:
          action === "approve" ? "APPROVER_APPROVED" : "APPROVER_REJECTED",
      };
      await API.post(`ticket/update-ticket-status/`, payload);
      history.goBack();
    } catch (err) {
      console.error(`Error during ${action} action:`, err);
      setError(`Failed to ${action} the form: ${err.message}`);
    } finally{
      setIsDeleteModalLoading(false)
    }
  };

  const sendBackToRTA = async () => {
    try {
      const payload = {
        ticket_code: ticketCode,
        sub:userId,
        ticket_status: "RTA_RECTIFY",
      };

      const response = await API.post("ticket/update-ticket-status/", payload);

      if (response) {
        history.goBack();
      }
    } catch (error) {
      console.error(`Error sending ticket ${ticketCode} back to RTA:`, error);
    }
  };

  if (loading) {
    return <div className={classes.loadingContainer}>Loading form data...</div>;
  }

  return (
    <div className={classes.root}>
      <Header
        ticketId={ticketCode}
        lastSaved={lastSaved}
        onAddCategories={handleOpenModal}
        onBack={handleBack}
      />

      <FormTabs
        visibleCategories={visibleCategories}
        activeTabIndex={activeTabIndex}
        onTabChange={handleTabChange}
      >
        <FormContent
          currentFormData={currentFormDataForRender}
          formResponses={currentFormResponses}
          loading={!currentFormDataForRender}
          error={error}
          onControlChange={handleControlChange}
          onMultiControlChange={handleMultiControlChange}
          validationErrors={validationErrors} // Pass down the errors
          formRemark={formRemarks || ""}
          formDividendEntries={formDividendEntries}
          onFormRemarkChange={(remark) => handleFormRemarkChange(remark)}
        />
      </FormTabs>

      <Footer
        ticketStatus={ticketStatus}
        handleOpenModal={handleOpenDialog}
        onApproveOrReject={handleApproveOrReject}
        onReset={handleReset}
        onSaveAsDraft={handleSaveAsDraft}
        onSubmit={handleSubmit}
        sendBackToRTA={sendBackToRTA}
      />

      <CategorySelectionModal
        open={modalOpen}
        onClose={handleCloseModal}
        availableCategories={allCategories}
        selectedCategories={visibleCategories}
        onCategoriesChange={handleCategoriesChange}
      />
      <ConfirmDelete
        openDialog={openDialog}
        onApproveOrReject={handleApproveOrReject}
        onClose={handleCloseDialog}
        reasonForReject={reasonForReject}
        setReasonForReject={setReasonForReject}
        isDeleteModalLoading={isDeleteModalLoading}
      />
    </div>
  );
}

export default Questionnaire;
